import { useState, useMemo } from "react";
import dayjs from "dayjs";

type CheckboxItems = {
  basicInfo: boolean;
  removeDate: boolean;
  withinOneYear: boolean;
};

export const useConfirmApplicationRemovalTaskRegister = (
  latestCreatedAt: Date,
  removeDate: Date,
) => {
  const [checkboxItems, setCheckboxItems] = useState<CheckboxItems>({
    basicInfo: false,
    removeDate: false,
    withinOneYear: false,
  });

  const removeDateWithinSevenDays = useMemo(() => {
    return Boolean(dayjs(removeDate).isBefore(dayjs().add(7, "day"), "day"));
  }, [removeDate]);

  const latestCreatedAtWithinOneYear = useMemo(() => {
    return Boolean(dayjs(latestCreatedAt).isAfter(dayjs().subtract(1, "year")));
  }, [latestCreatedAt]);

  const disableSubmitButton = useMemo(() => {
    if (!checkboxItems.basicInfo) return true;
    if (removeDateWithinSevenDays && !checkboxItems.removeDate) return true;
    if (latestCreatedAtWithinOneYear && !checkboxItems.withinOneYear)
      return true;
    return false;
  }, [
    checkboxItems.basicInfo,
    checkboxItems.removeDate,
    checkboxItems.withinOneYear,
    latestCreatedAtWithinOneYear,
    removeDateWithinSevenDays,
  ]);

  const setCheckBasicInfo = (checked: boolean) => {
    setCheckboxItems((prevState) => ({
      ...prevState,
      basicInfo: checked,
    }));
  };

  const setCheckRemoveDate = (checked: boolean) => {
    setCheckboxItems((prevState) => ({
      ...prevState,
      removeDate: checked,
    }));
  };

  const setCheckWithinOneYear = (checked: boolean) => {
    setCheckboxItems((prevState) => ({
      ...prevState,
      withinOneYear: checked,
    }));
  };

  return {
    checkboxItems,
    setCheckBasicInfo,
    setCheckRemoveDate,
    setCheckWithinOneYear,
    removeDateWithinSevenDays,
    latestCreatedAtWithinOneYear,
    disableSubmitButton,
  };
};
